/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `Payment3DSCallback` for the Caintra Connect frontend.
 * @module pages/Payment3DSCallback
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Payment 3DS Callback Component
 *
 * This component is loaded in a popup window after OpenPay redirects
 * the user back from 3DS authentication. It closes the popup and optionally
 * sends a message to the parent window.
 */
const Payment3DSCallback = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Close the popup window
    window.close();

    // Fallback: notify parent window via postMessage
    if (window.opener) {
      const urlParams = new URLSearchParams(window.location.search);
      const chargeId = urlParams.get("id");

      // Both callback page and parent window are in the same React app (same origin)
      // Use current origin as target since parent window validates: event.origin === window.location.origin
      const targetOrigin = window.location.origin;

      window.opener.postMessage(
        {
          type: "3DS_COMPLETE",
          chargeId: chargeId,
        },
        targetOrigin,
      );
    }
  }, []);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <p>{t("components.paymentModal.threeDSCallbackMessage")}</p>
    </div>
  );
};

export default Payment3DSCallback;
